const $ = require("jquery");

$(document).ready(() => {
  $(".editor table, .modal table").wrap("<div class='responsive-table'></div>");
});
